import React from 'react';
import { usePropertyProofOfOccupancyFile } from '../../../../queries/PropertyFileFields';
import { FileOrFormQuestion } from '../FileOrFormQuestion';
import { usePropertyCertificateOfOccupancy } from '../../../../queries/PropertyFields';
import { CertificateOfOccupancyType } from '@apply/constants';

interface ProofOfOccupancyFileProps {
    propertyGuid: string;
    required: boolean;
    isReview?: boolean;
}

export const ProofOfOccupancyFile: React.FC<ProofOfOccupancyFileProps> = ({ required, propertyGuid, isReview = false }) => {
    const {
        handleMode,
        setHandleMode,
        filename: uploadFileName,
        setFilename: setUploadFileName,
        fileApiId: uploadedFileApiId,
        setFileApiId: setUploadedFileApiId,
    } = usePropertyProofOfOccupancyFile(propertyGuid);
    const [certificateOfOccupancy] = usePropertyCertificateOfOccupancy(propertyGuid);

    const generateLabel = () => {
        switch (certificateOfOccupancy) {
            case CertificateOfOccupancyType.Yes:
                return 'Certificate of Occupancy';
            case CertificateOfOccupancyType.LocalEquivalent:
                return 'CO equivalent';
            case CertificateOfOccupancyType.TCO:
                return 'TCO or Other';
            case CertificateOfOccupancyType.No:
            default:
                return '';
        }
    };

    return (
        <div className='form-group'>
            <div className='row'>
                <FileOrFormQuestion
                    label={generateLabel()}
                    selector='proof of occupancy'
                    fileType={'proof of occupancy'}
                    required={required}
                    isReview={isReview}
                    propertyGuid={propertyGuid}
                    handle={handleMode}
                    onHandleChange={setHandleMode}
                    uploadFileName={uploadFileName}
                    onUploadFileNameChange={setUploadFileName}
                    uploadedFileApiId={uploadedFileApiId}
                    onUploadedFileApiIdChange={setUploadedFileApiId}
                />
            </div>
        </div>
    );
};
